const firstUpperCase = w => (w.length > 1 ? w[0].toUpperCase() + w.slice(1, w.length) : w.toUpperCase());

const queryStringAsObject = qs => {
  const obj = {};
  qs.split('?')[1]
    .split('&')
    .forEach(param => {
      obj[param.split('=')[0]] = param.split('=')[1];
    });
  return obj;
};

export default {
  firstUpperCase,
  normalize: s => {
    let _s = [s, '']
      .join(' ')
      .replace('_', ' ')
      .replace('&', ' ')
      .toLowerCase();

    return _s
      .split(' ')
      .map(w => firstUpperCase(w))
      .join('');
  },
  queryStringAsObject
};



// WEBPACK FOOTER //
// ./src/helpers/stringHelper.js